import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '@cd/sdds-common-components-react';

const fetchCsdsStreamData = (requestPayload : csdRequestInput, systemName: string): AxiosPromise<CsdsMsgResponseType> => csttFacadeApi.post(`csttfacade/docs/v1/systems/${systemName}/csds`, requestPayload);

export {
    fetchCsdsStreamData
 };